'use strict';

var KeyMirror = require('keymirror');
var _clientOinMaxLength = 8;

var applicationLinkTypes = KeyMirror({
        EXISTING_LISTED_CLIENT: null,
        EXISTING_NOT_LISTED_CLIENT: null,
        NEW_CLIENT: null
    });

module.exports = {
    ActionTypes: KeyMirror({
        UPDATE_CLIENT_OIN: null,
        SET_CLIENT_OIN: null,
        CLIENT_OIN_UPDATED: null,
        FORWARD_FROM_CLIENT_OIN: null,
        UPDATE_CLIENT_SEARCH: null,
        CLIENT_SEARCH_COMPLETED: null,
        CLIENT_SEARCH_STARTED: null,
        CLEAR_CLIENT_SEARCH: null,
        CLIENT_RETRIEVE_STARTED: null,
        CLIENT_RETRIEVE_FAILED: null,
        CLIENT_RETRIEVE_COMPLETED: null
    }),
    SearchResult: KeyMirror({
        UNKNOWN: null,
        FOUND: null,
        NOT_FOUND: null
    }),
    ClientOin: {
        id: 'clientOin',
        model: 'clientOin',
        placeholder: 'Enter OIN',
        maxLength: _clientOinMaxLength,
        validationRules: { clientOin: 'required|numeric2|exactLength:' + _clientOinMaxLength },
        customAttributeNames: { clientOin: 'Client OIN' },
        value: null
    },
    ClientSearch: {
        id: 'clientSearch',
        model: 'clientSearch',
        placeholder: 'Search by name or OIN',
        validationRules: { clientSearch: 'required' },
        customAttributeNames: { clientSearch: 'Client name or OIN' },
        value: null
    },
    ApplicationLinkTypes: applicationLinkTypes,
    ClientTypeOptions: [
        {
            id: applicationLinkTypes.EXISTING_LISTED_CLIENT,
            name: 'Yes, to an existing client listed with me',
            displayLabel: 'Yes, to an existing account with my adviser'
        },
        {
            id: applicationLinkTypes.EXISTING_NOT_LISTED_CLIENT,
            name: 'Yes, to an existing client new to me',
            displayLabel: 'Yes, to an existing account'
        },
        {
            id: applicationLinkTypes.NEW_CLIENT,
            name: 'No, application for a new client',
            displayLabel: 'No'
        }],
    InvestorTypeOptions: [
        {
            isExisting: true,
            name: 'I am an existing investor',
            displayLabel: 'Yes, to an existing account'
        },
        {
            isExisting: false,
            name: 'I am a new investor',
            displayLabel: 'No'
        }
    ]
        
    ,
    ApplicationLinkLabel: 'Application linked'
};



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/SelectCustomerConstants.js